import type {
  RunningConnectorInvocationModel,
  RunningConnectorInvocationsPage,
} from '@/adapters/apiv1.g';
import type {
  RunningInvocation,
  RunningInvocations,
} from '@/types/core/client';
import type { UUID } from '@/utils/uuid';

function extractRunningInvocation(
  model: RunningConnectorInvocationModel
): RunningInvocation {
  return {
    claimedBy: (model.claimed_by ?? undefined) as UUID | undefined,
    connectorId: (model.connector_id ?? undefined) as UUID | undefined,
    featureId: (model.feature_id ?? undefined) as UUID | undefined,
    runSequence: model.run_sequence,
    startedAt: model.started_at ?? '',
  };
}

/**
 * Transform the backend running-invocations page to the frontend shape.
 * Rows join to agents via claimedBy == clientId (the presence WorkerID).
 */
export function extractRunningInvocations(
  model: RunningConnectorInvocationsPage
): RunningInvocations {
  return {
    invocations: (model.invocations ?? []).map(extractRunningInvocation),
    truncated: model.truncated ?? false,
  };
}
